import CaseInterventions from './CaseInterventions.vue';

export default CaseInterventions;
